var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "d-flex justify-content-between p-1" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-start align-items-center" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "pl-05" }, [
            _c("h5", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.__("admin_dashboard.top_engaged_users"))),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pl-05" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.show_filters = !_vm.show_filters
              },
            },
          },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.__("globals.filter_options")) +
                "\n                "
            ),
            !_vm.show_filters
              ? _c("i", { staticClass: "feather icon-chevron-down" })
              : _c("i", { staticClass: "feather icon-chevron-up" }),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.show_filters
      ? _c("div", { staticClass: "p-1 text-capitalize" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "required", attrs: { for: "month" } }, [
              _vm._v(_vm._s(_vm.__("globals.time"))),
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.month,
                    expression: "month",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "month" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.month = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.months_array, function (month, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: month.value } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(month.name) +
                        "\n                "
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary w-50",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.getUserEngagement()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.__("globals.search")))]
            ),
          ]),
        ])
      : _c("div", { staticClass: "text-center" }, [
          _vm.is_loading
            ? _c("div", [_vm._m(1)])
            : !_vm.is_loading && _vm.users.length > 0
            ? _c(
                "div",
                { staticClass: "ml-05 mr-05" },
                [
                  _vm._l(_vm.users, function (user, index) {
                    return [
                      _c("user-engagement-card", {
                        key: index,
                        attrs: { user: user },
                      }),
                    ]
                  }),
                ],
                2
              )
            : _c("div", [
                _c("p", [_vm._v(_vm._s(_vm.__("globals.no_users_yet")))]),
              ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "avatar avatar-sm bg-rgba-warning p-50 m-0",
        staticStyle: { width: "30px", height: "30px" },
      },
      [
        _c("div", { staticClass: "avatar-content" }, [
          _c("i", {
            staticClass: "feather icon-user-check text-warning font-medium-2",
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }